module.exports = __webpack_public_path__ + "img/close-circle.9cc26aeb.svg";